<template>
	<modal-tipo-documento
		ref="modalTipoDocumento"
		:exibir="exibir"
		@confirmar="confirmar"
		@fechar-modal="fecharModal"
		:tipo-documento="tipoDocumento"
	></modal-tipo-documento>
</template>

<script>
import ModalTipoDocumento from '@/views/pages/configuracao/tipo-documento/modal-tipo-documento/ModalTipoDocumento.vue'
import { actionTypes, mutationTypes } from '@/core/constants'

export default {
	name: 'editar-tipo-documento',
	components: { ModalTipoDocumento },
	props: {
		exibir: {
			type: Boolean,
		},
		tipoDocumento: {
			type: Object,
			required: true,
		},
	},
	methods: {
		async confirmar(data) {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EDITAR_TIPO_DOCUMENTO, data)

			this.$refs.modalTipoDocumento.limparTipoDocumento()
			this.mostrarNotificacaoSucesso('Tipo de documento editado com sucesso!')
			this.recarregarListagemExterna()
			this.fecharModal()
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		recarregarListagemExterna() {
			this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
			this.$emit('recarregar-listagem-tipo-documento')
		},
	},
}
</script>

<style scoped lang="stylus"></style>
